export const CATEGORIES = {
  sets: { label: 'Startersets & Sets', prefix: 'Set-', color: 'bg-yellow-500' },
  loks: { label: 'Loks', prefix: 'Lok-', color: 'bg-blue-600' },
  waggons: { label: 'Waggons', prefix: 'Wag-', color: 'bg-green-600' },
  gleise: { label: 'Gleise', prefix: 'Gls-', color: 'bg-slate-500' },
  weichen: { label: 'Weichen', prefix: 'Wch-', color: 'bg-orange-600' },
  signale: { label: 'Signale', prefix: 'Sig-', color: 'bg-red-600' },
  zubehoer: { label: 'Zubehör', prefix: 'Zub-', color: 'bg-purple-600' },
  zubehoer_ersatz: { label: 'Zubehör & Ersatzteile', prefix: 'ZubErs-', color: 'bg-pink-600' },
};

export const LIST_MAPPING = {
  manufacturer: 'manufacturers',
  epoch: 'epochs',
  railway: 'railways',
  system: 'systems',
  digital_type: 'digital_types',
  condition: 'conditions',
  coupling: 'couplings',
  type: 'waggon_types',
  track_system: 'track_systems',
  track_type: 'track_types',
  turnout_type: 'turnout_types',
  signal_type: 'signal_types',
  signal_function: 'signal_functions',
  signal_aspects: 'signal_aspects',
  prototype: 'prototypes',
  prototype_acc: 'prototypes_acc',
  base_option: 'base_options',
  decoder_type: 'decoder_types',
  category_acc: 'accessory_categories',
  acc_type: 'accessory_types',
  bridge_part: 'bridge_parts',
  level_crossing: 'level_crossings',
  location: 'locations',
  bool: 'boolean_options',
  drive: 'drive_types',
  kit_manufacturer: 'kit_manufacturers',
  transformer: 'transformer_options',
  light: 'light_options',
  lok_type: 'lok_type_options',
  interior_light: 'interior_light_options',
  // New Ersatzteile mappings
  category_ersatz: 'accessory_subcategories',
  decoder_types_detail: 'decoder_types_detail',
  protocols_detail: 'protocols_detail',
  interfaces_detail: 'interfaces_detail',
  central_protocols: 'central_protocols',
  booster_types: 'booster_types',
  landscape_manufacturers: 'landscape_manufacturers',
  figure_manufacturers: 'figure_manufacturers',
  spare_part_types: 'spare_part_types'
};

export const DB_FIELDS = [
  { key: 'inventory_id', label: 'Inventar-ID', required: false },
  { key: 'manufacturer', label: 'Hersteller' },
  { key: 'article_number', label: 'Artikelnummer' },
  { key: 'name', label: 'Name / Baureihe' },
  { key: 'category', label: 'Kategorie (loks, waggons, etc.)', required: true },
  { key: 'condition', label: 'Zustand' },
  { key: 'epoch', label: 'Epoche' },
  { key: 'railway', label: 'Bahnverwaltung' },
  { key: 'system', label: 'System' },
  { key: 'location', label: 'Standort' },
  { key: 'count', label: 'Anzahl' },
  { key: 'price_buy', label: 'Kaufpreis' },
  { key: 'price_catalog', label: 'Katalogwert' },
  { key: 'date_buy', label: 'Kaufdatum' },
  { key: 'note', label: 'Notiz' }
];